const setInfo = (prop, value) => {
  return {
    type: 'SET_INFO',
    payload: {
      prop,
      value
    }
  }
}

export {
  setInfo
}